var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413391 15.1304C1.1077 17.7067 2.63794 19.9395 4.69566 21.5205V15.1304H0.413391Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 23.9543C11.3005 23.984 11.6483 24 12 24C17.5443 24 22.2096 20.2396 23.5866 15.1304H10.9565V23.9543Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5866 8.86955C22.2096 3.76036 17.5443 0 12 0C11.6483 0 11.3005 0.0160312 10.9565 0.0456562V8.86955H23.5866Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69566 2.47945C2.63794 4.06054 1.1077 6.29334 0.413391 8.86954H4.69566V2.47945Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.4348H9.39136H9.39131V0.285233C8.28234 0.531139 7.23098 0.929717 6.26086 1.45908V10.4347V10.4347H0.101578C0.0347813 10.9471 0 11.4695 0 12C0 12.5305 0.0347813 13.0529 0.101578 13.5652H6.26081H6.26086V22.5409C7.23098 23.0702 8.28234 23.4689 9.39131 23.7147V13.5653V13.5652H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default __webpack_public_path__ + "static/media/norway.4dcd0d4e687b151ff2978c1573880cd8.svg";
export { ForwardRef as ReactComponent };